import "../../styles/DashBoard_Firmware.css";
import { useEffect, useRef, useState } from "react";
import {
  MdOutlineCloudUpload,
  MdOutlineFileUpload,
  MdClose,
  MdPerson,
  MdLogout,
  MdRefresh,
  MdCalendarToday,
  MdArrowForward,
  MdNewReleases,
  MdCheckCircle,
  MdOutlineBugReport,
  MdDevices,
  MdLayers,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ShowSnacker from "./ShowSnacker";
import firmware from "../../assets/firmware.png";
import { apiFetch } from "../../services/api";

function DashBoardFirmwareUpdate() {
  const navigate = useNavigate();
  const FileUseRef = useRef(null);
  const [showForm, setShowForm] = useState(false);

  const [snack, setSnack] = useState({open: false,message: "",type: "info"});
  const ShowSnackbar = (message:any, type= "info") => {
    setSnack({ open: true, message, type});
  };
  //====== Form Data
  const [FirmwareVersion, setFirmwareVersion] = useState("");
  const [Features, setFeatures] = useState("");
  const [Compatibility, setCompatibility] = useState("");
  const [BugFixes, setBugFixes] = useState("");
  const [FirmwareFile, setFirmwareFile] = useState<File | null>(null);
  const [latestfirmware, setlatestfirmware] = useState<any[]>([]);
  const [selectedFirmware, setSelectedFirmware] = useState<any | null>(null);
  // console.log(latestfirmware[0],"latestfirmware[0]");
  
  const allowedExtensions = ["bin", "hex"];

  const isValidExtension = (file: File) => {
    const ext = file.name.split(".").pop()?.toLowerCase();
    return ext ? allowedExtensions.includes(ext) : false;
  };

  // const Logout = () => {
  //   localStorage.removeItem("userEmail");
  //   localStorage.clear();
  //   navigate("/login", { replace: true });
  // };

  const view = () => {
    // console.log("inside view all");
    navigate('/dashboard/firmwares');
  }

  useEffect(() => {
    const fetchlatest3firmware = async() => {
      try{
        const response = await apiFetch("/firmware/latest3", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if(!response.ok) {
          throw new Error('HTTP error! Status');
        }

        const data = await response.json();
        setlatestfirmware(data);
        
        // console.log(data);
      } catch (err){
        // console.error("Error fetching firmware data");  
      }
    }
    fetchlatest3firmware();
  },[])

  // const [selectedFirmware, setSelectedFirmware] = useState(latestfirmware[0]);
  // console.log(latestfirmware[0],latestfirmware.length,selectedFirmware);
  

  useEffect(() => {
  if (latestfirmware.length && !selectedFirmware) {
    const latest = latestfirmware.find(f => f.latest);
    setSelectedFirmware(latest || latestfirmware[0]);
  }
}, [latestfirmware]);

  const refreshPage = () => {
    navigate(0);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const handleSubmit = async(e) => {
  e.preventDefault();

  if (!FirmwareVersion.trim()) {
    // console.log("Please enter the firmware version");
    ShowSnackbar("Please enter the Firmware Version","error");
    return;
  }

  if (!FirmwareFile) {
    // console.log("Please upload firmware file");
    ShowSnackbar("Please upload firmware file","error");
    return;
  }
  if(!Features || !Compatibility || !BugFixes){
    // console.log("Please fill the Required Details");
    ShowSnackbar("Please fill the Required Details","error");
    return;
  }
  // ShowSnackbar("Firmware update in progress...","loading");

  const formData =  new FormData();
  // console.log(FirmwareFile,FirmwareVersion);
  
  formData.append("firmware",  FirmwareFile);
  formData.append("version", FirmwareVersion);
  formData.append("features", Features);
  formData.append("compatibility", Compatibility);
  formData.append("bugfixes", BugFixes);
  // console.log("formdata", formData);
  // console.log([...formData]);
  
  const response = await apiFetch("/firmware/update", {
    method: "POST",
    body: formData
  });

  // console.log(response);
  const res = await response.json();
  // console.log(res, response.status);
  
  if(response.status === 200){
    // console.log(res.message);
    ShowSnackbar(res.message,"success");
    resetForm();
    setShowForm(false);
    setTimeout(() => {
      refreshPage();
    }, 3000);
    // window.location.reload();
  } else if(response.status === 400) {
    ShowSnackbar(res.message,"error");
    // resetForm();
    // setShowForm(false);
  } else {
    ShowSnackbar("Internal Server Error","error");
    resetForm();
    setShowForm(false);
  }
  
  // ✅ All validations passed
  // console.log("Ready to upload",FirmwareFile, Features, Compatibility, BugFixes );
  };

  const resetForm = () => {
    setFirmwareVersion("");
    setFeatures("");
    setCompatibility("");
    setBugFixes("");
    setFirmwareFile(null);
    if(FileUseRef.current){
      FileUseRef.current.value="";
    }
  };

  const parseList = (value: any): string[] => {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);

      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch {
      // Not JSON, treat it as a single value
    }

    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

  const featuresList = parseList(selectedFirmware?.features);
  const bugFixesList = parseList(selectedFirmware?.fix || selectedFirmware?.bugfixes);
  const compatList = parseList(selectedFirmware?.compatibility);

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "N/A";
    try {
      const d = new Date(dateStr);
      return isNaN(d.getTime())
        ? dateStr
        : d.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="dashboard-firmware-update">
      {/* Unified Top Header matching Dashboard Overview, Master MAC & Profile */}
      <div className="firmware-header">
        <div className="header-title-section">
          <h2>Firmware Upgrade</h2>
          <p>Upgrade, deploy, and manage certified firmware for all registered devices</p>
        </div>

        <div className="firmware-header-actions">
          <button
            type="button"
            className="add-user-btn"
            onClick={() => setShowForm(true)}
            title="Upload New Firmware"
          >
            <MdOutlineFileUpload size={18} />
            <span>Upload Firmware</span>
          </button>

          <button
            type="button"
            className="user-btn-secondary profile-link-btn"
            onClick={() => navigate("/dashboard/profile")}
          >
            <MdPerson size={18} />
            <span>My Profile</span>
          </button>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <span
              className="round-header-icon"
              onClick={refreshPage}
              title="Refresh"
            >
              <MdRefresh size={20} color="#4b5563" />
            </span>
            <span
              className="round-header-icon logout"
              onClick={handleLogout}
              title="Logout"
            >
              <MdLogout size={18} color="#dc2626" />
            </span>
          </div>
        </div>
      </div>

      {/* Firmware Versions Section */}
      <div className="fw-section-header">
        <div className="fw-section-title-wrap">
          <h3 className="fw-section-title">Active Firmware Releases</h3>
          <p className="fw-section-subtitle">Click a version build below to view release notes, modifications, and target hardware</p>
        </div>
      </div>

      <div className="fw-cards-grid">
        {latestfirmware.map((fw) => {
          const isSelected = selectedFirmware?.version === fw.version;
          const displayDate = formatDate(fw.createdAt);

          return (
            <div
              key={fw._id || fw.version}
              className={`fw-version-card ${fw.latest ? "is-latest" : "is-previous"} ${isSelected ? "is-active" : ""}`}
              onClick={() => setSelectedFirmware(fw)}
            >
              <div className="fw-card-top">
                <span className={`fw-badge ${fw.latest ? "badge-latest" : "badge-archived"}`}>
                  {fw.latest ? "Latest Certified" : "Previous Build"}
                </span>
                {isSelected && <span className="fw-active-indicator">Selected</span>}
              </div>

              <div className="fw-card-body">
                <span className="fw-version-prefix">Firmware Release</span>
                <h4 className="fw-version-code">v{fw.version}</h4>
              </div>

              <div className="fw-card-footer">
                <span className="fw-date-text">
                  <MdCalendarToday size={13} />
                  <span>{displayDate}</span>
                </span>
                <span className="fw-card-status-hint">
                  {isSelected ? "Inspecting" : "Select to inspect"}
                </span>
              </div>
            </div>
          );
        })}

        {/* View All Card */}
        <div className="fw-view-all-card" onClick={view} title="View all firmware history">
          <div className="fw-view-all-content">
            <span className="fw-view-all-label">Complete Archive</span>
            <span className="fw-view-all-title">View All Builds</span>
          </div>
          <div className="fw-view-all-btn">
            <span>Directory</span>
            <MdArrowForward size={16} />
          </div>
        </div>
      </div>

      {/* Release Notes & Specifications Container */}
      <div className="fw-details-container">
        <div className="fw-details-header">
          <div className="fw-details-title-group">
            <div className="fw-details-version-badge">
              <MdNewReleases size={20} color="#e60000" />
              <h4>Release Notes & Specifications — v{selectedFirmware?.version || "..."}</h4>
              {selectedFirmware?.latest ? (
                <span className="fw-badge badge-latest">Current Certified Release</span>
              ) : (
                <span className="fw-badge badge-archived">Archived Build</span>
              )}
            </div>
            <p className="fw-details-subtitle">
              Deployment timestamp: {formatDate(selectedFirmware?.createdAt)} &bull; OTA Channel Active
            </p>
          </div>

          <div className="fw-details-meta-chips">
            <span className="fw-meta-chip">
              <MdDevices size={14} />
              <span>Hardware: {selectedFirmware?.compatibility || "Rydio"}</span>
            </span>
            <span className="fw-meta-chip format-chip">
              <MdLayers size={14} />
              <span>Format: .bin / .hex</span>
            </span>
          </div>
        </div>

        <div className="fw-specs-grid">
          {/* Card 1: Features */}
          <div className="fw-spec-card">
            <div className="fw-spec-card-header">
              <div className="fw-spec-title">
                <MdCheckCircle size={18} color="#16a34a" />
                <h5>New Features & Enhancements</h5>
              </div>
              <span className="fw-count-pill green">{featuresList.length}</span>
            </div>
            <div className="fw-spec-content">
              {featuresList.length > 0 ? (
                <ul className="fw-styled-list features-list">
                  {featuresList.map((f, i) => (
                    <li key={i}>
                      <span className="fw-bullet-dot dot-green" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="fw-empty-spec">No feature modifications recorded for this build.</div>
              )}
            </div>
          </div>

          {/* Card 2: Bug Fixes */}
          <div className="fw-spec-card">
            <div className="fw-spec-card-header">
              <div className="fw-spec-title">
                <MdOutlineBugReport size={18} color="#dc2626" />
                <h5>Bug Fixes & System Stability</h5>
              </div>
              <span className="fw-count-pill red">{bugFixesList.length}</span>
            </div>
            <div className="fw-spec-content">
              {bugFixesList.length > 0 ? (
                <ul className="fw-styled-list fixes-list">
                  {bugFixesList.map((f, i) => (
                    <li key={i}>
                      <span className="fw-bullet-dot dot-red" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="fw-empty-spec">No bug fixes reported for this build.</div>
              )}
            </div>
          </div>

          {/* Card 3: Compatibility & Hardware specs */}
          <div className="fw-spec-card">
            <div className="fw-spec-card-header">
              <div className="fw-spec-title">
                <MdDevices size={18} color="#2563eb" />
                <h5>Hardware Compatibility & Specs</h5>
              </div>
              <span className="fw-count-pill blue">{compatList.length || 1}</span>
            </div>
            <div className="fw-spec-content">
              <div className="fw-compat-tags">
                {compatList.length > 0 ? (
                  compatList.map((item, i) => (
                    <span key={i} className="fw-compat-badge">
                      {item}
                    </span>
                  ))
                ) : (
                  <span className="fw-compat-badge">Universal</span>
                )}
              </div>

              <div className="fw-spec-meta-block">
                <div className="fw-meta-row">
                  <span className="fw-meta-k">Delivery Channel:</span>
                  <span className="fw-meta-v">Over-The-Air (OTA)</span>
                </div>
                <div className="fw-meta-row">
                  <span className="fw-meta-k">Integrity Check:</span>
                  <span className="fw-meta-v text-success">CRC32 Checksum Verified</span>
                </div>
                <div className="fw-meta-row">
                  <span className="fw-meta-k">Target OS:</span>
                  <span className="fw-meta-v">Embedded FreeRTOS</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Compact Quick Deploy Strip */}
        <div className="fw-quick-deploy-strip">
          <div className="fw-deploy-strip-left">
            <div className="fw-strip-icon-circle">
              <MdOutlineCloudUpload size={22} />
            </div>
            <div className="fw-strip-text">
              <h6>Deploy Next Firmware Build</h6>
              <p>Package, certify, and broadcast an updated firmware binary to the connected device fleet.</p>
            </div>
          </div>
          <button
            type="button"
            className="fw-strip-upload-btn"
            onClick={() => setShowForm(true)}
          >
            <MdOutlineFileUpload size={18} />
            <span>Upload New Firmware</span>
          </button>
        </div>
      </div>

      {/* Upload Firmware Modal Overlay */}
      {showForm && (
        <div className="firmware-modal-overlay" onClick={() => { resetForm(); setShowForm(false); }}>
          <div className="firmware-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="firmware-modal-header">
              <div className="modal-header-titles">
                <h3>Upload Firmware Build</h3>
                <p>Provide release notes and attach signed binary (.bin / .hex) for deployment</p>
              </div>
              <button
                type="button"
                className="modal-close-icon-btn"
                onClick={() => { resetForm(); setShowForm(false); }}
                title="Close"
              >
                <MdClose size={20} />
              </button>
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="firmware-modal-form">
              <div className="modal-form-grid">
                <div className="modal-field-group">
                  <label className="modal-field-label">
                    <span>Firmware Version</span>
                    <span className="req-star">*</span>
                  </label>
                  <input
                    type="text"
                    className="modal-field-input"
                    placeholder="e.g. 1.0.0 or 0.0.0.22"
                    value={FirmwareVersion}
                    onChange={(e) => setFirmwareVersion(e.target.value)}
                  />
                </div>

                <div className="modal-field-group">
                  <label className="modal-field-label">
                    <span>Target Compatibility</span>
                    <span className="req-star">*</span>
                  </label>
                  <select
                    value={Compatibility}
                    onChange={(e) => setCompatibility(e.target.value)}
                    className="modal-field-select"
                  >
                    <option value="">Select Compatible Device</option>
                    <option value="Rydio">Rydio</option>
                  </select>
                </div>
              </div>

              <div className="modal-field-group">
                <label className="modal-field-label">
                  <span>New Features & Capabilities</span>
                  <span className="req-star">*</span>
                </label>
                <textarea
                  className="modal-field-textarea"
                  placeholder="List new features (comma-separated or line-separated)..."
                  value={Features}
                  onChange={(e) => setFeatures(e.target.value)}
                  rows={3}
                />
              </div>

              <div className="modal-field-group">
                <label className="modal-field-label">
                  <span>Bug Fixes & Resolved Issues</span>
                  <span className="req-star">*</span>
                </label>
                <textarea
                  className="modal-field-textarea"
                  placeholder="List bug fixes (comma-separated or line-separated)..."
                  value={BugFixes}
                  onChange={(e) => setBugFixes(e.target.value)}
                  rows={3}
                />
              </div>

              <div className="modal-field-group">
                <label className="modal-field-label">
                  <span>Firmware Binary File</span>
                  <span className="req-star">*</span>
                </label>
                <div className="modal-file-dropzone">
                  <input
                    type="file"
                    id="firmware-file-input"
                    className="file-hidden-input"
                    ref={FileUseRef}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      if (!isValidExtension(file)) {
                        ShowSnackbar("Only .bin or .hex firmware files are allowed", "error");
                        e.target.value = "";
                        return;
                      }
                      setFirmwareFile(file);
                    }}
                  />
                  <label htmlFor="firmware-file-input" className="file-dropzone-label">
                    <MdOutlineFileUpload size={26} color="#e60000" />
                    {FirmwareFile ? (
                      <div className="file-selected-info">
                        <span className="file-name-highlight">{FirmwareFile.name}</span>
                        <span className="file-size-info">
                          ({(FirmwareFile.size / 1024).toFixed(1)} KB) &bull; Click to change
                        </span>
                      </div>
                    ) : (
                      <div className="file-prompt-info">
                        <span className="prompt-primary">Click to select firmware file</span>
                        <span className="prompt-secondary">Supported formats: .bin, .hex (Max 50 MB)</span>
                      </div>
                    )}
                  </label>
                </div>
              </div>

              <div className="firmware-modal-actions">
                <button
                  type="button"
                  className="modal-action-btn secondary"
                  onClick={() => { resetForm(); setShowForm(false); }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="modal-action-btn neutral"
                  onClick={resetForm}
                >
                  Clear Fields
                </button>
                <button
                  type="submit"
                  className="modal-action-btn primary"
                  onClick={handleSubmit}
                >
                  Upload & Deploy
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <ShowSnacker
        open={snack.open}
        message={snack.message}
        type={snack.type}
        className="firmwareupdate-snackbar"
        onClose={() => setSnack(s => ({ ...s, open: false }))}
      />
    </div>
  );
}

export default DashBoardFirmwareUpdate;